import * as React from "react"
import { StoryblokComponent } from "gatsby-source-storyblok";
import Layout from "../components/layout"
import useStoryblok from "../utils/storyblok"
 
const Page = ({ pageContext, location }) => { 
  let story = pageContext.story
  story = useStoryblok(story, location)
  // console.log(story)
 
  return (
  <Layout>
    <StoryblokComponent blok={story.content} />
  </Layout>
)}
 
export default Page